import $ from 'jquery';
import _ from 'lodash';
import { store } from '../../App/store';
import {
  updateFolderTemplates,
  pushNewTemplate,
  replaceTemplate,
  removeTemplates,
  moveTemplatesToHome,
  moveTemplatesToFolder,
  unselectAllIds,
} from '../ViewDesigns/redux/modules/templates';
import { HOME_FOLD_NAME } from './consts';
import { updateUserData } from '../ViewDesigns/redux/modules/user';
import { openSnackbar } from '../ViewDesigns/redux/modules/templates';
import {wrapAjax} from 'MyAccount/ViewDesigns/helpers/preferencesHelper';

export function renameFolder(id, newName) {
  return $.ajax({
    type: 'POST',
    cache: false,
    url: '/application/user/edit-tag',
    data: {
      tagId: id,
      name: newName,
    },
  }).done(data => {
    if (data.success) {
      const { tags } = store.getState().user;
      store.dispatch(updateUserData({tags: Object.assign({}, tags, {[id]: newName})}));
    }
  });
}

export function newFolder(name) {
  return $.ajax({
    type: 'POST',
    cache: false,
    url: '/application/user/add-tag',
    data: {name},
  }).done(data => {
    if (data.success) {
      const { tags } = store.getState().user;
      store.dispatch(updateUserData({tags: Object.assign({}, tags, {[data.id]: data.name})}));
    }
  });
}

export function updateTemplates(id) {
  store.dispatch(unselectAllIds());
  return $.ajax({
    type: 'GET',
    cache: false,
    url: '/application/user/get-templates-by-tag?folderId=' + id,
  }).done(data => {
    if (data.success) {
      store.dispatch(updateFolderTemplates({id, templates: data.templates}));
    }
  });
}

export function copyTemplate(folderId, id, title) {
  return $.ajax({
    type: 'POST',
    cache: false,
    url: '/application/user/duplicate-template',
    data: {
      name: title,
      templateId: id
    }
  }).done(data => {
    if (data.success) {
      const { templates: { userTemplates } } = store.getState();
      const template = userTemplates[folderId].filter(item => item.id === Number(id));
      store.dispatch(pushNewTemplate({
        folder: folderId,
        template: {
          name: title,
          id: data.id,
          thumbnailUrl: template && template[0] ? template[0].thumbnailUrl : null,
          modifiedAt: new Date() / 1000, createdAt: new Date() / 1000},
      }));
    }
  });
}

export function deleteFolder(id) {
  return $.ajax({
    type: 'GET',
    cache: false,
    url: '/application/user/delete-tag/' + id,
  }).done(data => {
    if (data.success) {
      const { user: { tags }, templates: { userTemplates } } = store.getState();
      const newTags = {};
      const needRefresh = !userTemplates.hasOwnProperty(id);
      for (const key in tags) {
        if (key !== id && tags.hasOwnProperty(key)) {
          newTags[key] = tags[key];
        }
      }
      store.dispatch(updateUserData({tags: newTags}));
      if (needRefresh) {
        updateTemplates('0');
      } else {
        store.dispatch(moveTemplatesToHome({id}));
      }
    }
  });
}

export function renameTemplate(folderId, id, title) {
  return $.ajax({
    type: 'POST',
    cache: false,
    url: '/application/user/rename-template',
    data: {
      name: title,
      templateId: id
    }
  }).done(data => {
    if (data.success) {
      store.dispatch(replaceTemplate({
        folder: folderId,
        template: {name: title, id: data.id},
      }));
    }
  });
}

export function restoreTemplates(templatesIdArray, destFolderId = '0', secondTime = false) {
  return $.ajax({
    type: 'POST',
    cache: false,
    url: '/application/user/recover-template',
    data: {
      newFolderId: `'${destFolderId}'`,
      templateId: templatesIdArray,
    }
  }).done(data => {
    if (data.success) {
      store.dispatch(moveTemplatesToFolder({
        sourceFolderId: '1',
        destFolderId: destFolderId,
        templatesIdArray,
      }));
      if (!secondTime) {
        store.dispatch(openSnackbar({
          message: `Template${templatesIdArray.length > 1 ? 's' : ''} restored to Home`,
          action: 'undo',
          actionFunc: () => {
            moveToTrash('0', templatesIdArray, true); // eslint-disable-line
          },
        }));
      } else {
        store.dispatch(openSnackbar({message: 'Your action has been undone.'}));
      }
    }
  });
}

export function moveToTrash(folderId, templatesIdArray, secondTime = false) {
  return $.ajax({
    type: 'POST',
    cache: false,
    url: '/application/user/trash-template',
    data: {
      templateId: templatesIdArray
    }
  }).done(data => {
    if (data.success) {
      store.dispatch(moveTemplatesToFolder({
        sourceFolderId: folderId,
        destFolderId: '1',
        templatesIdArray,
      }));
      if (!secondTime) {
        store.dispatch(openSnackbar({
          message: `The template${templatesIdArray.length > 1 ? 's' : ''} has been deleted`,
          action: 'undo',
          actionFunc: () => {
            restoreTemplates(templatesIdArray, folderId, true);
          },
        }));
      } else {
        store.dispatch(openSnackbar({message: 'Your action has been undone.'}));
      }
    }
  });
}

export function deleteTemplates(templatesIdArray, folderId = '1') {
  return $.ajax({
    type: 'POST',
    cache: false,
    url: '/application/user/delete-template',
    data: {
      templateId: templatesIdArray,
    },
  }).done(() => {
    store.dispatch(removeTemplates({
      folderId,
      templatesIdArray,
    }));
  });
}

export function moveTemplates(sourceFolderId, destFolderId, templatesIdArray, secondTime = false) {
  return $.ajax({
    type: 'POST',
    cache: false,
    url: '/application/user/move-template',
    data: {
      newFolderId: destFolderId,
      templateId: templatesIdArray,
    }
  }).done((data) => {
    if (data.success) {
      store.dispatch(moveTemplatesToFolder({
        sourceFolderId,
        destFolderId,
        templatesIdArray,
      }));
      const { tags } = store.getState().user;
      const data = {
        message: `
         The template${templatesIdArray.length > 1 ? 's' : ''} has been moved \n
         to "${destFolderId === '0' ? HOME_FOLD_NAME : _.truncate(tags[destFolderId], {length: 15})}"
        `,
        action: 'undo',
        actionFunc: () => {
          moveTemplates(destFolderId, sourceFolderId, templatesIdArray, true);
        }
      };
      if (secondTime) {
        data.message = 'Your action has been undone.';
        data.action = '';
      }
      store.dispatch(openSnackbar(data));
    }
  });
}

export const sendToAdmin = wrapAjax((templateId) => {
  return $.ajax({
    method: 'POST',
    url: '/application/user/send-to-admin',
    cache: false,
    data: {
      templateId: templateId
    }
  });
});
